import { createContext, useContext } from 'react'

import BackendClient from '~/api/BackendClient/BackendClient'
import { CustomCultureStatusResponse } from '~/api/backend/customCultureStatusAPI'
import useQuery from '~/api/backend/useQuery'
import {
  CultureStatus,
  CustomCultureStatus,
  parseCustomCultureStatusResponse,
  SYSTEM_CULTURE_STATUSES,
} from '~/utils/cultureStatus'

const CustomCultureStatusContext = createContext<CustomCultureStatus[]>([])

export function CustomCultureStatusProvider({
  children,
}: React.PropsWithChildren<unknown>) {
  let { data } = useQuery<null, CustomCultureStatusResponse[]>({
    backendQueryParams: {
      apiQuery: async (client: BackendClient) => client.customCultureStatuses.getAll(),
      apiParams: null,
    },
  })

  let value: CustomCultureStatus[] = []
  if (data) {
    value = data
      .map(s => parseCustomCultureStatusResponse(s))
      .sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1))
  }

  return (
    <CustomCultureStatusContext.Provider value={value}>
      {children}
    </CustomCultureStatusContext.Provider>
  )
}

export function useCultureStatuses(): CultureStatus[] {
  const customStatuses = useContext(CustomCultureStatusContext)
  return SYSTEM_CULTURE_STATUSES.concat(customStatuses)
}
